(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeHome(root) {
      if (!root || root.dataset.amReady) return;
      root.dataset.amReady = 'true';
      const disclosures = [...root.querySelectorAll('[data-am-disclosure]')];
      disclosures.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) disclosures.forEach((other) => { if (other !== details) other.open = false; });
        });
      });
      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        disclosures.forEach((details) => {
          if (!details.open) return;
          details.open = false;
          details.querySelector('summary').focus();
        });
      });
      document.addEventListener('click', (event) => {
        disclosures.forEach((details) => { if (!details.contains(event.target)) details.open = false; });
      });
    }
    document.querySelectorAll('[data-am-home]').forEach(initializeHome);
    document.addEventListener('shopify:section:load', (event) => initializeHome(event.target.querySelector('[data-am-home]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
